module.exports = __webpack_public_path__ + "img/lt1.c214a66a.png";